import { Capacitor, registerPlugin } from '@capacitor/core';

type KeychainPlugin = {
	get: (options: { key: string }) => Promise<{ value: string | null }>;
	set: (options: { key: string; value: string }) => Promise<void>;
	remove: (options: { key: string }) => Promise<void>;
};

/** Implemented in the iOS app target (ios/App/App/Keychain.swift); no other platform has it. */
export const Keychain = registerPlugin<KeychainPlugin>('Keychain');

export function isKeychainAvailable(): boolean {
	return Capacitor.isPluginAvailable('Keychain');
}
